import React, { useState } from "react";
import "./SupportWidget.css";
import { auth } from "../firebase";

function SupportWidget() {

  const apiBase = process.env.REACT_APP_API_URL || "";

  const [open, setOpen] = useState(false);
  const [step, setStep] = useState("start");

  const [message, setMessage] = useState("");
  const [botReply, setBotReply] = useState("");

  const [ticket, setTicket] = useState("");
  const [ticketId, setTicketId] = useState("");

  const [category, setCategory] = useState("");

  // --------------------------
  // FAQ Request
  // --------------------------

  const handleFAQ = async () => {

    const res = await fetch(`${apiBase}/api/support-chat`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ message })
    });

    const data = await res.json();

    if (data.type === "faq") {
      setBotReply(data.message);
      setStep("faq-response");
    } else {
      setStep("ticket");
    }

  };

  // --------------------------
  // Suggested Question
  // --------------------------

  const handleSuggestion = async (text) => {

    setMessage(text);

    const res = await fetch(`${apiBase}/api/support-chat`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ message: text })
    });

    const data = await res.json();

    if (data.type === "faq") {
      setBotReply(data.message);
      setStep("faq-response");
    } else {
      setStep("ticket");
    }

  };

  // --------------------------
  // Submit Support Ticket
  // --------------------------

// --------------------------
// Navigation Helpers
// --------------------------

const goBack = () => {

  if (step === "faq-response" || step === "ticket") {
    setStep(category.toLowerCase().split(" ")[0]); // return to category
  } else {
    setStep("start");
  }

};

const resetSupport = () => {

  setStep("start");
  setMessage("");
  setTicket("");
  setBotReply("");
  setTicketId("");
  setCategory("");

};


  const handleSubmit = async () => {

    if (!ticket.trim()) {
      alert("Please describe your issue before submitting.");
      return;
    }

    const userEmail = auth?.currentUser?.email || "Unknown User";

    let platform = "Web";

    if (window.webkit?.messageHandlers) platform = "iOS App";
    if (window.AndroidBridge) platform = "Android App";

    const res = await fetch(`${apiBase}/api/support-ticket`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: userEmail,
        message: ticket,
        platform: platform,
        category: category
      })
    });

    const data = await res.json();

    setTicketId(data.ticketId);
    setStep("submitted");

  };

  return (
    <>
      <div className="support-toggle" onClick={() => setOpen(!open)}>
        💬
      </div>

      {open && (
        <div className="support-widget">

          {/* START */}

          {step === "start" && (
            <>
              <h4>EmployPilot Support</h4>
              <p>What can we help you with?</p>

              <button onClick={() => {setCategory("Account"); setStep("account");}}>
                Account & Login
              </button>

              <button onClick={() => {setCategory("Billing"); setStep("billing");}}>
                Billing & Subscriptions
              </button>

              <button onClick={() => {setCategory("Resume Generator"); setStep("resume");}}>
                Resume Generator
              </button>

              <button onClick={() => {setCategory("LinkedIn Generator"); setStep("linkedin");}}>
                LinkedIn Generator
              </button>

              <button onClick={() => {setCategory("Community Hub"); setStep("community");}}>
                Community Hub
              </button>

              <button onClick={() => {setCategory("Technical Issue"); setStep("technical");}}>
                Technical Issue
              </button>
            </>
          )}

          {/* ACCOUNT */}

          {step === "account" && (
            <>
              <p>Describe your account issue:</p>

              <div className="suggestions">
                <button onClick={() => handleSuggestion("forgot password")}>
                  Forgot my password
                </button>

                <button onClick={() => handleSuggestion("account login")}>
                  Can't log into my account
                </button>

                <button onClick={() => handleSuggestion("account locked")}>
                  Account access issue
                </button>
              </div>

              <textarea
                placeholder="Example: Can't log into my account."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />

              <button onClick={handleFAQ}>Get Help</button>

              <div className="support-nav">
              <button onClick={goBack}>Back</button>
              </div>
            </>
          )}

          {/* BILLING */}

          {step === "billing" && (
            <>
              <div className="suggestions">

                <button onClick={() => handleSuggestion("pro features locked")}>
                  Pro features are locked
                </button>

                <button onClick={() => handleSuggestion("charged twice")}>
                  Charged twice
                </button>

                <button onClick={() => handleSuggestion("cancel subscription")}>
                  Cancel my subscription
                </button>

              </div>
                <textarea
                 placeholder="Example: How do I cancel subscription?"
                 value={message}
                 onChange={(e) => setMessage(e.target.value)}
              />

                <button onClick={handleFAQ}>Get Help</button>

                <div className="support-nav">
                <button onClick={goBack}>Back</button>
                </div>

              </>
          )}

          {/* RESUME */}

          {step === "resume" && (
            <>
              <p>Describe your Resume Generator issue:</p>

              <div className="suggestions">

                <button onClick={() => handleSuggestion("resume pdf not downloading")}>
                  Resume PDF won't download
                </button>

                <button onClick={() => handleSuggestion("resume didnt generate")}>
                  Resume didn't generate
                </button>

                <button onClick={() => handleSuggestion("resume looks bad")}>
                  Resume needs improvement
                </button>

              </div>

              <textarea
                placeholder="Example: My resume didn't generate correctly."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />

              <button onClick={handleFAQ}>Get Help</button>

              <div className="support-nav">
              <button onClick={goBack}>Back</button>
              </div>
            </>
          )}

          {/* LINKEDIN */}

          {step === "linkedin" && (
            <>
              <p>Describe your LinkedIn Generator issue:</p>

              <div className="suggestions">

                <button onClick={() => handleSuggestion("connect linkedin account")}>
                  Why doesn't it connect to LinkedIn?
                </button>

                <button onClick={() => handleSuggestion("export linkedin profile")}>
                  How do I export my LinkedIn profile?
                </button>

                <button onClick={() => handleSuggestion("copy linkedin content")}>
                  How do I copy the generated profile?
                </button>

              </div>

              <textarea
                placeholder="Example: How do I export the LinkedIn profile content?"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />

              <button onClick={handleFAQ}>Get Help</button>

              <div className="support-nav">
              <button onClick={goBack}>Back</button>
              </div>
            </>
          )}

          {/* COMMUNITY */}

          {step === "community" && (
            <>
              <div className="suggestions">

                <button onClick={() => handleSuggestion("how to post community")}>
                  How do I create a post?
                </button>

                <button onClick={() => handleSuggestion("reply community post")}>
                  How do I reply to discussions?
                </button>

                <button onClick={() => handleSuggestion("community page issue")}>
                  Community page issue
                </button>

              </div>

              <textarea
                placeholder="Example: I can't reply to posts."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />

              <button onClick={handleFAQ}>Get Help</button>

              <div className="support-nav">
              <button onClick={goBack}>Back</button>
              </div>
            </>
          )}

          {/* TECHNICAL */}

          {step === "technical" && (
            <>
              <div className="suggestions">

                <button onClick={() => handleSuggestion("page not loading")}>
                  Page not loading
                </button>

                <button onClick={() => handleSuggestion("something not working")}>
                  Something isn't working
                </button>

                <button onClick={() => handleSuggestion("error message")}>
                  I received an error
                </button>

              </div>

              <textarea
                placeholder="Example: My page not loading."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />

              <button onClick={handleFAQ}>Get Help</button>

              <div className="support-nav">
              <button onClick={goBack}>Back</button>
              </div>
            </>
          )}

          {/* FAQ RESPONSE */}

          {step === "faq-response" && (
            <>
              <p>{botReply}</p>

              <button onClick={() => setStep("ticket")}>
                Still need help
              </button>

              <div className="support-nav">
              <button onClick={goBack}>Back</button>
              </div>
            </>
          )}

          {/* TICKET */}

          {step === "ticket" && (
            <>
              <textarea
                placeholder="Describe your issue..."
                value={ticket}
                onChange={(e) => setTicket(e.target.value)}
              />

              <button onClick={handleSubmit}>
                Submit Support Ticket
              </button>

              <div className="support-nav">
              <button onClick={goBack}>Back</button>
              </div>
            </>
          )}

          {/* SUBMITTED */}

          {step === "submitted" && (
            <p>
              ✅ Ticket sent.<br/>
              Reference ID: <strong>{ticketId}</strong><br/>
              Our team will respond soon.

              <div className="support-nav">
              <button onClick={goBack}>Back</button>
              </div>
            </p>
          )}

        </div>
      )}
    </>
  );
}

export default SupportWidget;